import { Avatar, AvatarUser } from '@dixa/lib-shared-habla';
import { ampli } from 'lib-shared-tracking';
import { User } from 'lib-shared-types-api';

import { AppLink } from 'components/appLink';

import styles from './contactsTableUser.module.scss';

export type PickedProps = Pick<User, 'name'>;

export interface ContactsTableUserProps extends PickedProps {
  avatarUser: AvatarUser;
}

export const ContactsTableUser = ({
  name,
  avatarUser,
}: ContactsTableUserProps): JSX.Element => (
  <div className={styles.root}>
    <Avatar user={avatarUser} size="24" />

    <AppLink
      path="/contacts/user/:id"
      params={{ path: { id: avatarUser.id } }}
      onClick={() => ampli.contactsCardViewUserClicked()}
    >
      {name}
    </AppLink>
  </div>
);

export default ContactsTableUser;
